<template>
  <div
    class="image-input"
    :class="{
      'hover': hover,
      'empty': !src,
    }"
    @mouseenter="hover = true;"
    @mouseleave="hover = false;"
    @dragenter="hover = true;"
    @dragleave="hover = false;"
    @drop.prevent="receiveFile($event.dataTransfer.files)"
    @dragover.prevent
    @click="$refs.fileUpload.click()">
    <img
      :src="src"
    />
    <div
      class="image-preview-overlay flex-column justify-center align-center white--text">
      <h1>Click Or Drop New Image Here</h1>
      <div>Maximum Size: 5MB.<br>Supported File Types: JPG, PNG, & GIF.</div>
      <input
        ref="fileUpload"
        @input="receiveFile($refs.fileUpload.files)"
        type="file"
        accept="image/png,image/gif,image/jpeg"
        hidden
      />
      <v-btn
        v-if="clearable && src"
        class="image-clear mt-5"
        @click.stop="src = '';"
        depressed>
        Clear
      </v-btn>
    </div>
    <div class="image-click-icon">
      <v-icon>mdi-information-outline</v-icon>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'ImageInput',
  props: ['value', 'clearable'],
  data() {
    return {
      hover: false,
      src: '',
    };
  },
  watch: {
    value(value) {
      this.src = value;
    },
    src(src) {
      this.$emit('input', src);
    },
  },
  methods: {
    receiveFile(files) {
      if (!files) return;

      files = Array.from(files);

      const image = this.validateFile(files);

      if (!image) return;

      const reader = new FileReader();

      reader.onload = (e) => {
        this.src = e.target.result;
      };

      reader.readAsDataURL(image);
    },
    validateFile(files) {
      const errors = [];
      let [image] = files;
      const size = (image.size / 1024 / 1024).toFixed(4);

      if (files.length !== 1) {
        errors.push('&bull; You may only upload one image file at a time.');
      }

      if (!_.includes(image.type, 'image')) {
        errors.push('&bull; You may only upload image files (JPG, PNG, & GIF)');
      }

      if (size > 5) {
        errors.push('&bull; Image file size may not exceed 5MB.');
      }

      if (errors.length) {
        image = false;
        this.showWarning(
          errors.join('<br>'),
          'The following errors occured',
        );
      }

      return image;
    },
  },
  created() {
    this.src = this.value;
  },
};
</script>

<style lang="scss">
.image-input {
  position: relative;
  display: inline-block;
  cursor: pointer;
  border: 5px solid #dddddd;

  img {
    pointer-events: none;
    max-width: 100%;
  }

  .image-click-icon {
    position: absolute;
    pointer-events: none;
    bottom: 0;
    right: 0;
    height: 30px;
    width: 30px;
    padding: 4px 0 0 4px;
    background: #dddddd;
  }

  .image-preview-overlay {
    display: none;
    position: absolute;
    pointer-events: none;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(100, 100, 100, 0.8);
    padding: 20px;
    text-align: center;

    h1 {
      width: 100%;
      font-size: 24px !important;
      line-height: 60px;
    }

    .image-clear {
      pointer-events: all;
    }
  }

  &.empty {
    min-width: 500px;
    min-height: 500px;

    .image-click-icon {
      display: none;
    }
  }

  &.hover,
  &.empty {
    border: 5px dashed #dddddd;

    .image-preview-overlay {
      display: flex;
    }
  }
}
</style>
